import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from 'react';
import { variant1 } from './constants';
const SpecialOffersContext = createContext(variant1);
export const SpecialOffersContextProvider = ({ variant, children }) => (_jsx(SpecialOffersContext.Provider, { value: variant, children: children }));
export function useConfigurationByVariant(config) {
    var _a;
    const variant = useContext(SpecialOffersContext);
    if (!variant) {
        throw new Error('useConfiguration must be used within a ConfigurationProvider');
    }
    return (_a = config[variant]) !== null && _a !== void 0 ? _a : {};
}
export default SpecialOffersContext;
